import React from 'react';
import './Process.css';

const Process = () => {
  const processSteps = [
    {
      step: "01",
      title: "Define Business Objectives",
      description: "Align with strategic goals: Ensure that the project aligns with the company's long-term vision and objectives."
    },
    {
      step: "02", 
      title: "Stakeholders & Needs",
      description: "Involve stakeholders: Include input from key stakeholders like business leaders, end-users"
    },
    {
      step: "03",
      title: "Establish Selection Criteria", 
      description: "Feasibility: Is the project technically feasible? Consider the technology stack, skill sets, and resource availability."
    },
    {
      step: "04",
      title: "Evaluate Project Options",
      description: "Cost-benefit analysis: Compare the expected benefits with the costs to determine the ROI"
    },
    {
      step: "05",
      title: "Prioritize Projects",
      description: "Rank the projects based on the established criteria. This can involve a simple scoring model"
    },
    {
      step: "06", 
      title: "Consider Technical",
      description: "Existing infrastructure: Assess whether the project fits into your current infrastructure or if upgrades are needed"
    },
    {
      step: "07",
      title: "Resource Availability", 
      description: "Resource Availability Human resources: Do you have the necessary people with the right skills to work"
    },
    {
      step: "08",
      title: "Analyze Long-term Impact",
      description: "Will the project remain viable and valuable in the long term? Consider the longevity of technology choices"
    },
    {
      step: "09",
      title: "Conduct a Pilot or Prototype",
      description: "For large, complex projects, you may want to conduct a pilot or develop a prototype to assess its feasibility"
    },
    {
      step: "10", 
      title: "Make a Decision",
      description: "After evaluating the options, prioritize the projects based on strategic importance, feasibility, and alignment with business goals"
    },
    {
      step: "11",
      title: "Monitor and Adjust",
      description: "Once the project is selected and initiated, continue to monitor progress against goals and timelines."
    }
  ];

  return (
    <section className="process section" id="process">
      <div className="container">
        <div className="section-header text-center">
          <p className="process-label">PROCESS</p>
          <h2>Codes AI WORK PROCESS</h2>
          <h3>How to work it!</h3>
        </div>

        <div className="process-grid">
          {processSteps.map((item, index) => (
            <div key={index} className="process-card" data-aos="fade-up" data-aos-delay={index * 100}>
              <div className="process-step">
                <span className="step-number">{item.step}</span>
                <div className="step-icon">
                  <i className="fas fa-check"></i>
                </div>
              </div>
              <div className="process-content">
                <h4>{item.title}</h4>
                <p>{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process; 